import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import EstimateForm from '../../components/feature/EstimateForm';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesGrid from './components/ServicesGrid';
import BeforeAfter from './components/BeforeAfter';
import AIAnswers from './components/AIAnswers';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import LeadFormSection from './components/LeadFormSection';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import HomeFAQ from './components/HomeFAQ';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  const [formOpen, setFormOpen] = useState(false);

  return (
    <div className="min-h-screen font-sans">
      <Header onEstimateClick={() => setFormOpen(true)} />
      <main>
        <HeroSection onEstimateClick={() => setFormOpen(true)} />
        <TrustBar />
        <ServicesGrid onEstimateClick={() => setFormOpen(true)} />
        <BeforeAfter onEstimateClick={() => setFormOpen(true)} />
        <ProcessSection />
        <WhyChooseUs onEstimateClick={() => setFormOpen(true)} />
        <LeadFormSection />
        <AIAnswers />
        <Testimonials />
        <ServiceAreas onEstimateClick={() => setFormOpen(true)} />
        <HomeFAQ />
        <FinalCTA onEstimateClick={() => setFormOpen(true)} />
      </main>
      <Footer onEstimateClick={() => setFormOpen(true)} />
      <EstimateForm isOpen={formOpen} onClose={() => setFormOpen(false)} />
    </div>
  );
}
